import React from "react";
import styled from "styled-components";
import { Colors } from "../../config";

const DropdownRentCar = ({ closeDropdown, selected, onRentACar, carTypes }) => {
  const handleSelect = (selected) => {
    closeDropdown();
    onRentACar(selected);
  };
  return (
    <DropdownWrapper>
      <DropdownList>
        {carTypes.map((item) => (
          <DropdownItem
            selected={item.id === selected}
            key={item.id}
            onClick={() =>
              handleSelect({
                target: { value: item.id, name: "carType" },
              })
            }
          >
            {item.name}
          </DropdownItem>
        ))}
      </DropdownList>
    </DropdownWrapper>
  );
};

export default DropdownRentCar;

// Styled Components

const DropdownWrapper = styled.div``;

const DropdownList = styled.div`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const DropdownItem = styled.div`
  padding: 16px 12px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  color: ${(props) => (props.selected ? Colors.white : Colors.prussianBlue)};
  background: ${(props) =>
    props.selected ? Colors.prussianBlue : Colors.white};
  &:hover {
    background-color: ${(props) =>
      props.selected ? Colors.prussianBlue : "#f0f0f0"};
    color: ${(props) => (props.selected ? Colors.white : Colors.prussianBlue)};
  }
`;
